<template>
  <div id="users-list">
    <SidebarLayout2 :breadcrumb="breadcrumb" pageTitle="Descontos exclusivos">
      <!-- SIDEBAR -->
      <template #sidebar>
        <Heading element="h2" class="sidebar--title">
          Ações da página
        </Heading>
        <div class="sidebar--buttons">
          <PmwButton
            :hasIcon="true"
            variation="blue-100"
            class="sidebar--buttons"
            element="router-link"
            link="/desconto-exclusivo/create"
          >
            Cadastrar desconto
          </PmwButton>

          <PmwButton
            :disabled="selectedRows.length !== 1"
            :link="
              selectedRows.length === 1
                ? `/desconto-exclusivo/edit/${selectedRows[0].codigo}`
                : '#'
            "
            variation="blue-100"
            class="sidebar--buttons"
            element="router-link"
            target="_blank"
          >
            Editar
          </PmwButton>

          <!-- DESATIVAR -->
          <PmwButton
            v-if="
              statusFilter.value === true ||
                selectedRows?.[0]?.ativo === 'Ativo'
            "
            :disabled="!selectedRows.length"
            layout="outline"
            variation="blue-100"
            class="sidebar--buttons"
            @click="handleActivation"
          >
            Desativar
          </PmwButton>

          <!-- ATIVAR -->
          <PmwButton
            v-if="
              statusFilter.value === false ||
                selectedRows?.[0]?.ativo === 'Desativado'
            "
            :disabled="selectedRows.length !== 1"
            layout="outline"
            variation="blue-100"
            class="sidebar--buttons"
            @click="handleActivation"
          >
            Ativar
          </PmwButton>
        </div>
      </template>

      <!-- CONTEÚDO -->
      <template #content>
        <span class="filters">
          <!-- BUSCA -->
          <SearchInput
            v-model="searchTerm"
            class="filters--search-input"
            @input="searchData"
          />
        </span>
        <span class="filters--row">
          <!-- FILTRO STATUS -->
          <FilterDropdown
            v-model="statusFilter"
            :options="statusFilterOptions"
            label="Status"
            @input="applyFilters()"
          />

          <!-- FILTRO HOTEIS -->
          <FilterDropdown
            v-model="hotelFilter"
            :options="hotelFilterOptions"
            :radioOptions="false"
            label="Hotéis"
            class="filters--dropdown"
            hasSearch
            @input="applyFilters()"
          />
        </span>
        <!-- TABELA -->
        <DataTable
          :cols="cols"
          :rows="rows"
          :isLoading="loading"
          :selectableRow="true"
          :selectedRowHasBgColor="true"
          :searchableColumns="['desconto', 'percentual']"
          :selectedsRowsTerms="'desconto selecionado | descontos selecionados'"
          :colsMinWidths="colsMinWidths"
          class="filters--datatable"
          @getSelectedRows="selectedRows = $event"
        >
          <template v-slot:editar="data">
            <router-link
              :to="`/desconto-exclusivo/edit/${data.rowDataObj.codigo}`"
              class="links--edit"
              target="_blank"
            >
              Editar
            </router-link>
          </template>

          <template v-slot:excluir="data">
            <div v-if="statusFilter.value">
              <span
                class="links--delete"
                @click="openModalDelete(data.rowDataObj)"
              >
                Desativar
              </span>
            </div>
            <div v-else>
              <span
                class="links--active"
                @click.stop.prevent="activateExclusiveDiscount(data.rowDataObj)"
              >
                Ativar
              </span>
            </div>
          </template>

          <template v-slot:percentual="slotProps">
            {{ slotProps.rowDataObj.percentual }} %
          </template>
        </DataTable>
        <!-- PAGINAÇÃO -->

        <PmwPagination
          v-show="paginationItems.length >= 10"
          :currentPage="pagination.currentPage"
          :itemsPerPage="pagination.itemsPerPage"
          :totalItems="pagination.totalItems"
          :items="paginationItems"
          :itemsPerPageOptions="pagination.itemsPerPageOptions"
          @changePagination="changePagination"
        />
        <!-- MODAL DELEÇÃO -->
        <PmwAlertModal
          v-model="showModal"
          :title="''"
          closeButton
          icon="alert"
          cancelButtonText="Voltar"
          confirmButtonText="Desativar"
          confirmButtonColor="blue-100"
          @alert-modal-confirm="deleteExclusiveDiscount"
          @alert-modal-cancel="showModal = false"
        >
          <template #text>
            <div class="modal--container-content">
              <PmwHeading class="modal--title">Desativar desconto</PmwHeading>
              <PmwParagraph size="paragraph-60" class="modal--paragraph">
                Ao desativar o desconto exclusivo, será necessário reativa-lo
                novamente
              </PmwParagraph>
            </div>
          </template>
        </PmwAlertModal>
      </template>
    </SidebarLayout2>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import PmwAlertModal from '@solucoes/components-lib-tmp/src/components/patterns/AlertModal'
import PmwButton from '@solucoes/components-lib-tmp/src/components/elements/PmwButton'
import DataTable from '@solucoes/components-lib-tmp/src/components/patterns/DataTable'
import FilterDropdown from '@solucoes/components-lib-tmp/src/components/patterns/FilterDropdown'
import Heading from '@solucoes/components-lib-tmp/src/components/elements/Heading'
import PmwPagination from '@solucoes/components-lib-tmp/src/components/patterns/PmwPagination'
import SearchInput from '@solucoes/components-lib-tmp/src/components/elements/SearchInput'
import SidebarLayout2 from '@/layouts/SidebarLayout2'
import PmwHeading from '@solucoes/components-lib-tmp/src/components/elements/PmwHeading'
import PmwParagraph from '@solucoes/components-lib-tmp/src/components/elements/PmwParagraph'

export default {
  name: 'ExclusiveDiscounts',
  components: {
    PmwAlertModal,
    PmwButton,
    DataTable,
    FilterDropdown,
    Heading,
    PmwPagination,
    SearchInput,
    SidebarLayout2,
    PmwHeading,
    PmwParagraph
  },

  data() {
    return {
      breadcrumb: [
        {
          label: 'Letsbook'
        },
        {
          label: 'Descontos exclusivos',
          url: '/admin/v2/desconto-exclusivo'
        }
      ],

      /** Filtros */
      filters: [],

      /** Colunas da tabela */
      cols: [
        {
          alias: 'Nome do desconto',
          name: 'desconto',
          sortable: true
        },
        {
          alias: 'Percentual do desconto',
          name: 'percentual',
          sortable: true
        },
        {
          alias: 'Situação',
          name: 'ativo',
          sortable: false
        },
        {
          alias: 'Ações',
          name: 'editar',
          sortable: false
        },
        {
          name: 'excluir',
          sortable: false
        }
      ],

      colsMinWidths: {
        desconto: '380px',
        percentual: '174px',
        ativo: '90px',
        editar: '70px',
        excluir: '70px'
      },

      /** V-model da busca */
      searchTerm: '',

      /** Dados da paginação */
      pagination: {
        currentPage: 1,
        itemsPerPage: 25,
        totalItems: 0,
        itemsPerPageOptions: [
          {
            text: '25',
            value: 25
          },
          {
            text: '50',
            value: 50
          },
          {
            text: '75',
            value: 75
          },
          {
            text: '100',
            value: 100
          }
        ]
      },

      paginationItems: [],

      /** Linhas da tabela (dados) */
      rows: [],

      /** Loading da tabela */
      loading: true,

      /** Array das linhas selecionadas */
      selectedRows: [],

      /** Usuário a ser deletado */
      userDelete: null,

      /** Exibição da modal de deleção */
      showModal: false,

      /** Opções do filtro de status */
      statusFilterOptions: [
        {
          label: 'Ativo',
          value: true,
          checked: true
        },
        {
          label: 'Desativado',
          value: false,
          checked: false
        }
      ],

      /** Opções do filtro de Hotel */
      hotelFilterOptions: [
        {
          label: 'Todos',
          value: -1,
          checked: true
        },
        {
          label: 'Sim',
          value: 1,
          checked: false
        },
        {
          label: 'Não',
          value: 0,
          checked: false
        }
      ],

      /** V-model do filtro de status */
      statusFilter: {
        label: 'Ativo',
        value: true,
        checked: true
      },

      /** V-model do filtro de hotel */
      hotelFilter: [],

      /** Todos descontos */
      allDiscounts: []
    }
  },

  computed: {
    /** Retorna um objeto com os valores dos itens selecionados nos filtros */
    activeFilters() {
      const filter = {
        desconto: this.searchTerm,
        ativo: this.statusFilter.value,
        hoteis: this.hotelFilter.map((item) => item.value) || []
      }
      return filter
    }
  },

  watch: {
    activeFilters: {
      handler() {
        this.applyFilters()
      },
      deep: true
    },

    'activeFilters.ativo'() {
      this.getExclusiveDiscount()
    }
  },

  async created() {
    this.loading = true

    await this.getHotels()

    await this.getExclusiveDiscount()

    this.loading = false
  },

  methods: {
    ...mapActions(['setLoadingBar']),

    handleActivation() {
      if (this.selectedRows[0].ativo === 'Ativo') {
        this.showModal = true
      } else {
        this.activateExclusiveDiscount(this.selectedRows[0])
      }
    },

    /**
     * Reativa um desconto exclusivo com base nos dados da linha fornecida.
     * @param {Object} rowData - Dados do desconto a ser reativado, incluindo informações como ID e outros campos relevantes.
     */
    async activateExclusiveDiscount(rowData) {
      try {
        const discountObj = this.allDiscounts.find(
          (item) => item.codigo === rowData.codigo
        )

        const payload = {
          ...discountObj,
          ativo: true
        }

        this.setLoadingBar(true)

        await this.$exclusiveDiscounts.updateExclusiveDiscount(payload)

        discountObj.ativo = true

        this.setLoadingBar(false)

        this.$bus.$emit('show-alert-chip', {
          message: 'Desconto reativado com sucesso!'
        })

        this.applyFilters()
      } catch (error) {
        this.setLoadingBar(false)

        this.$bus.$emit('show-alert-chip', {
          message: 'Erro ao reativar desconto exclusivo'
        })
      }
    },

    /**
     * Desbloqueia o usuário da lista
     * @param {Object} selectedRows: Objeto com usuário selecionado
     */
    openModalDelete(selectedRows) {
      this.showModal = true
      this.selectedRows = selectedRows
    },

    /** Desabilita o desconto exclusivo da lista de ativos */
    deleteExclusiveDiscount() {
      this.setLoadingBar(true)

      let dataDelete
      if (Array.isArray(this.selectedRows)) {
        dataDelete = this.selectedRows.map((a) => a.codigo)
      } else {
        dataDelete = this.selectedRows.codigo
      }

      this.$exclusiveDiscounts
        .deleteExclusiveDiscount(dataDelete)
        .then(() => {
          this.selectedRows = []
          this.getExclusiveDiscount()

          this.setLoadingBar(false)

          this.$bus.$emit('show-alert-chip', {
            message: 'Desconto desativado com sucesso!'
          })
        })
        .catch(() => {
          this.setLoadingBar(false)

          this.$bus.$emit('show-alert-chip', {
            message: 'Erro ao excluir desconto'
          })
        })
    },

    /** Busca os dados da tabela de acordo com a busca */
    searchData() {
      const searchTerm = this.searchTerm?.toLowerCase() || ''
      this.rows = this.paginationItems.filter((item) => {
        return (
          item.data.desconto?.toLowerCase().includes(searchTerm) ||
          item.data.percentual?.toLowerCase().includes(searchTerm) ||
          item.data.ativo?.toLowerCase().includes(searchTerm)
        )
      })
      this.pagination.currentPage = 1
    },

    /** Busca a lista de hotéis para o filtro */
    getHotels() {
      this.$initialSetting
        .getHotels({ ativo: true })
        .then((response) => {
          const data = response.data
          this.hotelFilterOptions = data.map((item) => {
            return {
              value: item.codigo,
              label: item.nome
            }
          })
        })
        .catch(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Erro ao buscar hotéis'
          })
        })
    },

    /** Aplica os filtros e passa os dados para standarizeTableData */
    applyFilters() {
      const filter = this.activeFilters

      const filteredData = this.allDiscounts.filter((item) => {
        return (
          this.matchDesconto(item, filter) &&
          this.matchStatus(item, filter) &&
          this.matchHoteis(item, filter)
        )
      })

      this.pagination.currentPage = 1
      this.standarizeTableData(filteredData)
    },

    /** Busca a lista de descontos exclusivos */
    getExclusiveDiscount() {
      this.setLoadingBar(true)

      this.loading = true
      this.selectedRows = []
      this.pagination.currentPage = 1
      this.searchTerm = ''

      this.$exclusiveDiscounts
        .getDiscountList(this.activeFilters.ativo)
        .then((response) => {
          this.allDiscounts = response.data
          this.applyFilters()
        })
        .catch(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Erro ao carregar a lista de descontos exclusivos'
          })
        })
        .finally(() => {
          this.loading = false
          this.setLoadingBar(false)
        })
    },

    /** Padroniza os dados para exibir na tabela
     * @param {Array} data: dados a serem padronizados
     */
    standarizeTableData(data) {
      const filter = this.activeFilters

      const filteredData = data?.filter((item) => {
        return (
          this.matchDesconto(item, filter) &&
          this.matchStatus(item, filter) &&
          this.matchHoteis(item, filter)
        )
      })
      this.paginationItems = filteredData?.map((item) => {
        return {
          data: {
            desconto: item.desconto,
            percentual: item.valor,
            ativo: item.ativo ? 'Ativo' : 'Desativado',
            hoteis: item.hoteis?.map((hotel) => hotel),
            codigo: item.codigo
          }
        }
      })
      this.pagination.totalItems = filteredData?.length ?? 0
      this.rows = this.paginationItems
    },

    /** Verifica se o desconto é igual ao filtro
     * @param {Object} item: item a ser verificado
     * @param {Object} filter: filtro a ser verificado
     */
    matchDesconto(item, filter) {
      if (!filter.desconto) return true
      return item.desconto
        ?.toLowerCase()
        .includes(filter.desconto.toLowerCase())
    },

    /** Verifica se o status é igual ao filtro
     * @param {Object} item: item a ser verificado
     * @param {Object} filter: filtro a ser verificado
     */
    matchStatus(item, filter) {
      if (filter.ativo === null) return true

      return item.ativo === filter.ativo
    },

    /** Verifica se o hotel é igual ao filtro
     * @param {Object} item: item a ser verificado
     * @param {Object} filter: filtro a ser verificado
     */
    matchHoteis(item, filter) {
      return (
        filter.hoteis.length === 0 ||
        (item.hoteis &&
          filter.hoteis.some((h) => item.hoteis.includes(Number(h))))
      )
    },

    /**
     * Maneja a paginação
     * @param {Object} event: dados da paginação
     */
    changePagination(event) {
      this.pagination.currentPage = event.currentPage
      this.rows = event.items
      toString(this.rows)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .pmw-dropdown--options {
  width: max-content;
  padding: 10px;
}

.pagination {
  ::v-deep {
    p {
      margin: 0;
    }
    .select--button {
      font-weight: 500;
    }
  }
}
::v-deep .content {
  /** Padding abaixo do título da página */
  .page-heading {
    padding-bottom: 24px;
  }
}
::v-deep .datable-grid-wrapper {
  .col {
    padding-left: 14px;
  }
}
.sidebar {
  &--title {
    line-height: 21px;
    color: $gray-darkest;
    text-align: left;
    margin-top: 35px;
    margin-bottom: 15px;
    margin-left: 15px;
  }
  &--buttons {
    display: flex;
    flex-direction: column;
    width: 215px;
    gap: 10px;
    margin: auto;
  }
}

.filters {
  display: flex;
  gap: 20px;

  &--search-input {
    width: 215px;
    margin-bottom: 25px;
  }

  &--row {
    display: flex;
    gap: 15px;
    margin-bottom: 15px;

    &::v-deep(.pmw-dropdown--trigger-button) {
      gap: 8px;
    }
  }

  &--datatable {
    ::v-deep {
      .pmw-col.pmw-th:nth-child(5) {
        pointer-events: none;
        border-right: none;
        .pmw-sort-icons {
          display: none;
        }
      }

      .pmw-col.pmw-th:nth-child(4) {
        pointer-events: none;
        .pmw-sort-icons {
          display: none;
        }
      }
    }
  }
}

::v-deep .pmw-datatable--row__selected-color {
  .links {
    &--edit {
      color: $pmw-white;
    }
  }
}
.links {
  &--edit {
    cursor: pointer;
    color: $blue;
  }
  &--active {
    cursor: pointer;
    border: none;
    background-color: none;
    color: $blue;
  }
  &--delete {
    cursor: pointer;
    border: none;
    background-color: none;
    color: $error;
  }
}

.filters-select {
  display: flex;
  width: 100%;
  position: relative;
  height: 40px;
  border: none;
  border-bottom: 1px solid $gray-darkest;

  & ::v-deep .pmw-dropdown--trigger-button {
    /** Remove o espaço antes do texto do dropdown de mais filtros */
    padding: 0;
  }
}
</style>
